function Ossetia({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_1859)">
  <path d="M31.0048 21.5656C31.648 19.8323 32 17.9576 32 16.0004C32 14.0433 31.648 12.1686 31.0048 10.4353L16 9.04395L0.995188 10.4353C0.352063 12.1686 0 14.0433 0 16.0004C0 17.9576 0.352063 19.8323 0.995188 21.5656L16 22.9569L31.0048 21.5656Z" fill="#D80027"/>
  <path d="M16 32.0002C22.8794 32.0002 28.7441 27.6582 31.0047 21.5654H0.995117C3.25587 27.6582 9.12049 32.0002 16 32.0002Z" fill="#FFDA44"/>
  <path d="M16 0C9.12049 0 3.25587 4.342 0.995117 10.4348H31.0048C28.7441 4.342 22.8794 0 16 0Z" fill="#F0F0F0"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default Ossetia;
